import { useFilters } from '@statsbomb/kitbag-global-football';
import { ReactNode, Suspense } from 'react';
import { EventCountInfoBar } from '@/components/visualisations/EventCountInfoBar';
import { METRIC_KEY } from '@/consts/searchKeys';
import { PromiseAtom } from '@/types/atom';
import { ConfigFilterSet } from '@/types/userConfigs';
import { FallbackLoading } from '../visualisations/FallbackLoading';
import { FullscreenPreviewLink } from './FullscreenPreviewLink';

export const EntityMetricPreviewPanel = ({
  pathTo,
  eventsForMetricCountAtom,
  filtersToHydrate,
  eventMap,
  children,
}: {
  pathTo?: string;
  eventsForMetricCountAtom: PromiseAtom<number>;
  filtersToHydrate: ConfigFilterSet;
  eventMap: ReactNode;
  children: ReactNode;
}) => {
  const [{ metric: metricKey }] = useFilters('main');

  return (
    <div className="flex flex-col relative">
      <div className="relative">
        {pathTo && metricKey && (
          <FullscreenPreviewLink
            to={{
              pathname: pathTo,
              search: new URLSearchParams({ [METRIC_KEY]: metricKey as string }).toString(),
            }}
            filtersToHydrate={filtersToHydrate}
          />
        )}
        <Suspense fallback={<FallbackLoading isPreview />}>{eventMap}</Suspense>
      </div>
      <EventCountInfoBar eventCountAtom={eventsForMetricCountAtom} />
      {children}
    </div>
  );
};
